import React from "react";
import { Heart } from 'lucide-react';

class AccountPhoto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isLiked: props.favorite === true,
      isMobile: window.innerWidth <= 768
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  handleError = () => {
    this.setState({ hasError: true });
  }

  handleLike = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      const csrfToken = document.querySelector('[name=csrf-token]');
      const headers = {
        'Content-Type': 'application/json'
      };
      
      if (csrfToken) {
        headers['X-CSRF-Token'] = csrfToken.content;
      }
      
      const response = await fetch('/like', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          media_item: { id: this.props.data.id }
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        this.setState({ isLiked: data.liked });
        
        if (this.props.onLikeChange) {
          this.props.onLikeChange(this.props.data.id, data.liked);
        }
      }
    } catch (error) {
      console.error('Error liking photo:', error);
    }
  };

  getFinalThumbnail() {
    const { image, thumbnail_src } = this.props.data;
    
    if (image && image.grid && image.grid.url) {
      return image.grid.url;
    }
    
    return thumbnail_src;
  }

  render() {
    const { data: photo, onPhotoClick } = this.props;
    const { isLiked, isMobile } = this.state;
    const finalThumbnail = this.getFinalThumbnail();

    return (
      <div className={`group relative overflow-hidden`}>
        {/* Photo Card */}
        <div className="bg-slate-800/30 overflow-hidden">
          {/* Image Container */}
          <div 
            className={`relative overflow-hidden ${isMobile ? 'aspect-square sm:aspect-auto' : 'aspect-square'}`}
            onClick={() => onPhotoClick(photo.id)}
          >
            <img 
              src={finalThumbnail} 
              className="w-full h-full object-cover"
              onError={this.handleError}
              alt={photo.description || ''}
            />
          
            {/* Content Type Badge */}
            <div className="absolute top-2 right-2 z-20">
              {photo.item_type === "slider" && (
                <div className="bg-black/40 backdrop-blur-sm text-white px-2 py-1 rounded-full text-xs flex items-center">
                  <i className="fas fa-clone mr-1"></i>
                  <span>Slider</span>
                </div>
              )}
              {photo.item_type === "single-video" && (
                <div className="bg-black/40 backdrop-blur-sm text-white px-2 py-1 rounded-full text-xs flex items-center">
                  <i className="fas fa-play mr-1"></i>
                  <span>Video</span>
                </div>
              )}
            </div>

            {/* Mobile-friendly overlay - always visible on mobile */}
            {!isMobile && (
              <div className="cursor-pointer absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent 
                opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              </div>
            )}
          </div>

          {/* Controls bar - always visible on mobile */}
          <div className={`flex items-center justify-between p-3 
            ${isMobile ? 'bg-slate-900' : ''}`}>
            {/* Likes & Views Counter */}
            <div className="flex items-center space-x-3">
              <div className="flex items-center space-x-1 text-white text-sm">
                <i className="fas fa-heart text-rose-500"></i>
                <span>{photo.likes}</span>
              </div>
              {photo.views_count && (
                <div className="flex items-center space-x-1 text-white text-sm">
                  <i className="fas fa-eye text-emerald-400"></i>
                  <span>{photo.views_count}</span>
                </div>
              )}
            </div>

            {/* Like Button */}
            <button 
              onClick={this.handleLike}
              className={`p-1.5 rounded-full transition-colors
                ${isMobile ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}
            >
              <Heart 
                className={`w-5 h-5 transition-all ${isLiked ? 'fill-rose-500 text-rose-500' : 'text-white'}`}
              />
            </button>
          </div>
        </div>
        
        {/* Spacer for mobile */}
        {isMobile && <div className="mb-4"></div>}
      </div>
    );
  }
}

export default AccountPhoto;